import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';

// eslint-disable-next-line boundaries/element-types -- FIXME
import { AbilitiesSelectors } from '@core/abilities-data';
import { Ability } from '@core/abilities-types';
import { TranslatePipe } from '@core/i18n-legacy';
import {
  DialogRef,
  DividerComponent,
  DropdownItemComponent,
  IconComponent,
  RtTooltip,
  TruncateComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rt-mailbox-select-footer',
  template: `
    @let canManageCompanyVal = canManageCompany();
    @if (showManageCompanyButton()) {
      <rt-divider />
      <rt-dropdown-item
        class="footer"
        [class.disabled]="!canManageCompanyVal"
        [rtTooltip]="
          'app.shared_mailboxes.email_provider_picker.manage_company_missing_tooltip' | translate
        "
        [rtTooltipMaxWidth]="315"
        [rtTooltipPosition]="'below'"
        [rtTooltipEnabled]="!canManageCompanyVal"
        [hasHoverEffect]="canManageCompanyVal"
        (click)="canManageCompanyVal ? goToSharedMailboxes() : null"
      >
        <rt-icon prefix [name]="'settings'" />
        <rt-truncate>{{
          'app.shared_mailboxes.email_provider_picker.manage_company_button' | translate
        }}</rt-truncate>
      </rt-dropdown-item>
    }
    @if (canManageEmailIntegrations()) {
      <rt-divider />
      <rt-dropdown-item class="footer" [isCreateAction]="true" (click)="goToEmailSettings()">
        <rt-icon prefix [name]="'add'" />
        <rt-truncate>{{
          'app.shared_mailboxes.email_provider_picker.connect_your_email' | translate
        }}</rt-truncate>
      </rt-dropdown-item>
    }
  `,
  styleUrl: './mailbox-select-footer.component.less',
  imports: [
    DropdownItemComponent,
    IconComponent,
    TruncateComponent,
    RtTooltip,
    DividerComponent,
    TranslatePipe,
  ],
})
export class MailboxSelectFooterComponent {
  private readonly dialog = inject(DialogRef, { optional: true });
  private readonly router = inject(Router);
  private readonly store = inject(Store);
  protected showManageCompanyButton = input.required<boolean>();

  protected canManageEmailIntegrations = this.store.selectSignal(
    AbilitiesSelectors.hasOne(Ability.ManageEmailIntegrations),
  );
  protected canManageCompany = this.store.selectSignal(
    AbilitiesSelectors.hasOne(Ability.ManageCompany),
  );

  protected goToSharedMailboxes() {
    this.navigate(['settings', 'shared_mailboxes', 'active']);
  }

  protected goToEmailSettings() {
    this.navigate(['settings', 'profile', 'email_settings']);
  }

  private navigate(path: string[]) {
    if (this.dialog) {
      this.dialog.close({ redirectTo: path });
      this.dialog.afterClosed.pipe(take(1)).subscribe(({ redirectTo }) => {
        if (redirectTo) {
          this.router.navigate(redirectTo);
        }
      });
    } else {
      this.router.navigate(path);
    }
  }
}
